/**
 * 检测当前运行环境是否为 Electron
 */
export const isElectron = (): boolean => {
  return typeof window !== 'undefined' && !!(window as any).electronAPI
}
